import * as React from 'react';
import {useMutation} from '@apollo/client/react';
import {BankAccount, TriggerFetchBankAccountData, TriggerFetchBankAccountDataMutation} from '../../types';
import {Button} from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

export interface FetchBankAccountDataButtonProps {
    bankAccount: BankAccount;
}

export function FetchBankAccountDataButton({bankAccount}: FetchBankAccountDataButtonProps) {
    const [triggerFetchBankAccountDataMutation] =
        useMutation<TriggerFetchBankAccountDataMutation>(TriggerFetchBankAccountData);

    return (
        <Button
            size="small"
            startIcon={<RefreshRoundedIcon />}
            onClick={() =>
                triggerFetchBankAccountDataMutation({
                    variables: {
                        bankAccountPublicId: bankAccount.publicId,
                    },
                })
            }
        >
            Odśwież dane
        </Button>
    );
}
